export default function IconCheck({
    className,
    pathClassName
}: {
    className?: string
    pathClassName?: string
}) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            height="24"
            width="24"
        >
            <path
                fill="currentColor"
                d="M23.914 6.914 8.5 22.328 0.086 13.914l2.828 -2.828L8.5 16.672 21.086 4.086l2.828 2.828Z"
            ></path>
        </svg>
    )
}
